import { createStore } from 'redux';
import rootReducer from '../reducers';
import { composeWithDevTools } from 'redux-devtools-extension';

export default initialState => {
    const composeEnhancers = composeWithDevTools({ rootReducer, trace: true });
    return createStore(rootReducer, initialState, composeEnhancers());
};
